import { action } from "typesafe-actions";

import { message } from "antd";

import { FAQActionTypes, FAQArticle, FAQCategory } from "./types";

export const faqCategoriesFetchRequest = () => action(FAQActionTypes.CATEGORIES_FETCH_REQUEST);

export const faqCategoriesFetchSuccess = (payload: { items: FAQCategory[] }) =>
  action(FAQActionTypes.CATEGORIES_FETCH_SUCCESS, payload);

export const faqCategoriesFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(FAQActionTypes.CATEGORIES_FETCH_ERROR);
};

export const faqArticleFetchRequest = (payload: { slug: string }) =>
  action(FAQActionTypes.ARTICLE_FETCH_REQUEST, payload);

export const faqArticleFetchSuccess = (payload: FAQArticle) => action(FAQActionTypes.ARTICLE_FETCH_SUCCESS, payload);

export const faqArticleFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(FAQActionTypes.ARTICLE_FETCH_ERROR);
};
